import {useState} from 'react'
import './App.css';
import ReactGA from 'react-ga';
import './fonts/DMSerifDisplay-Regular.ttf';

import Discipline from './Discipline';
import Select from 'react-select'

import data from './json/states-boards-requirements.json'


function App() {

  ReactGA.initialize('UA-205470393-2');

  const [selectedState, setSelectedState] = useState(null);
  const [profession, setProfession] = useState("")

  const handleSubmit = (evt) => {
    evt.preventDefault();
  }
  
  const getLetterText = (isEmail) => {

    return (
`${selectedState ? selectedState.label : "__________"} Medical Board, ${isEmail ? '%0D%0A%0D%0A' : ""}

I write as a practicing ${profession.length ? profession : "__________"} in the state of ${selectedState ? selectedState.label : "__________"} to request that you remove all language stigmatizing mental health in the state licensing application. ${isEmail ? '%0D%0A%0D%0A' : ""}

Suicide rates of healthcare workers are dramatically higher than the general public. Healthcare workers of all disciplines face enormous burnout and moral injury that are driving them from the bedside at record pace. We have labored at great personal risk and sacrifice through two years of a pandemic, and now begin to deal with the emotional implications of the trauma we have experienced. ${isEmail ? '%0D%0A%0D%0A' : ""}

Many healthcare workers report feeling unable to access mental health services due to concern for future career implications. Healthcare workers should always be safe and empowered to access mental healthcare services without fear of repercussion. In a career that requires compassion, focus, and sacrifice, we must prioritize the wellbeing of workers. ${isEmail ? '%0D%0A%0D%0A' : ""}

It is the responsibility of the Medical Board to ensure that the practitioners they credential are safe and qualified to practice to the best of their ability, for the safety and wellbeing of patients. The Board must remove any barriers to, and stigma surrounding, mental healthcare to ensure that providers are able to obtain the care they need to provide the best care possible to their patients. ${isEmail ? '%0D%0A%0D%0A' : ""}

Specifically, we request that the Board remove any questions during the licensing process that refer to diagnosed mental health conditions, or treatment for mental health conditions. These questions represent a violation of practitioner’s privacy, and actively discourage providers from accessing the care that they need. ${isEmail ? '%0D%0A%0D%0A' : ""}

We appreciate your prompt attention to this matter. ${isEmail ? '%0D%0A%0D%0A' : ""}

  `)
}

  async function copyTextToClipboard() {
    ReactGA.event({
      category: 'UserAction',
      action: 'Clicked Copy Letter to Clipboard',
      label: `${selectedState.value} - ${profession}`
    });

    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(getLetterText()) && alert('Copied');
    } else {
      return document.execCommand('copy', true, getLetterText()) && alert('Copied');
    }
  }

  
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  var debounceUpdateProfession = debounce(function(value) {
    setProfession(value)
  }, 0);

 
  return (
    <div className="App">
      <header>
        <h1>IMPACT &mdash; Mental Health Campaign 2022</h1>
        <p className="headerInfo">Healthcare workers in many states are currently required to disclose diagnosed mental health conditions. Many report feeling unable to access mental health services.<br/><br/><strong>Healthcare workers should always be safe and empowered to access mental healthcare services without fear of repercussion.</strong><br/><br/> Use this tool to find the rules in your state and contact credentialing boards to demand change.</p>
      </header>
      <main>
      <div className='chooseProfession'>
      
          <form onSubmit={handleSubmit} className='containForm'>
            <label className='formLabel'><span className='labelText'>Your profession:</span>
            <input className='professionInput' type="text" placeholder='Type your profession here' value={profession} onChange={e => debounceUpdateProfession(e.target.value)} />
            </label>
          </form>
        </div>

        <div className='chooseState'> 
          <div className='containForm'>
            <label className='formLabel'><span className='labelText'>Your state:</span>
              <br/>
            <Select
              className='select'
              defaultValue={selectedState}
              onChange={setSelectedState}
              options={data}
            />
            </label>
          </div>
        </div>
       
        
        {selectedState &&  (profession.length >= 2) &&
          <div className="cols">
            
            <div className="stateInfo">
              <h2>Rules in {selectedState.label}: </h2>
              <div style={{display: 'flex', flexDirection: 'column'}}>
              <p><i>Note: information is correct to the best of our knowledge, but may not be 100% complete.</i></p>
              <p className="mobileOnly"><strong>Scroll to the bottom of the page for full letter text to copy and send or read to your state's board.</strong></p>
              {selectedState.disciplines.map(discipline => <Discipline key={discipline.name} discipline={discipline} state={selectedState.label} letterText={getLetterText(true)}/>)}
              </div>
            </div>

            <div className="letter">
              <p><strong>Click "copy" to copy the letter below and then paste into your email client.</strong></p>
              <button onClick={copyTextToClipboard}>Copy</button>
              <br/>
              <br/>
              <textarea className="letterText" value={getLetterText()} readOnly/>
              <br />
            </div>
         
          </div>           
        }
      </main>
      <p>&copy; 2022 IMPACT in Healthcare</p>
      <p><strong><a target="_blank" href="https://www.impactinhealthcare.org" rel="noreferrer">https://www.impactinhealthcare.org</a></strong></p>
    </div>
  );
}

export default App;
